export const en = {
    Lang_cs: "Česky",
    Lang_en: "English",
    button_Pokracovat: "Continue",
    button_Close: "Close",
    SetFirstPassword_DokladFill: "Enter papers number to continue, please.",
    SetFirstPassword_HesloNastaveno: "Password was set",
    Form_HeslaNeshoduji: "Passwords are different",
    TypDokladu_ID: "Identity Card",
    TypDokladu_P: "Passport",
    TypDokladu_OSTATNI: "Other",
    TypDokladu_IR: "Residence permit",
    TypDokladu_VS: "Visa",
    TypDokladu_PS: "Residence permit label",
    TypDokladu_RP: "Driving licence",
    DokladForm_idDoklad_required: "Papers number is required",
    DokladForm_idDoklad_minLength: "Minimum length of Papers number is 8 characters.",
    DokladForm_idDoklad_maxLength: "Maximum length of Papers number is 9 characters.",
    DokladForm_typDokladu_required: "Papers type is required",
    DokladForm_cisloDokladu: "Papers number is required",
    NewPasswordForm_newPassword: "New pasword",
    NewPasswordForm_newPassword_repeat: "Re-enter new pasword",
    UserAgreementFormSection_agreement: "I agree to {1} and {2}.",
    UserAgreementFormSection_gdpr: "processing of personal data",
    UserAgreementFormSection_terms: "terms of use of the portal",
    UserAgreementFormSection_agreement2: "I agree to {1}.",
    UserAgreementFormSection_gdpr_and_terms: "processing of personal data and terms of use of the portal",
    UserAgreementFormSection_gdpr_detail: "Agree to the processing of personal data",
    UserAgreementFormSection_terms_detail: "Agree to the terms of use of the portal",
    ProcessLoginForm_cisloDokladu_required: "Enter papers number ",
    Form_agreement_required: "You have to agree to the processing of personal data and tems of use of the portal.",
    NewPasswordForm_newPassword_required: "Password is required",
    NewPasswordForm_newPassword_repeat_required: "Re-entering password is required",
    ResetPasswordPage_obnoveniHesla: "Reset password",
    ResetPasswordPage_done: "Instructions for reset password were sent to your registered e-mail.",
    ResetPasswordForm_login: "Username",
    ResetPasswordForm_login_required: "Username is required",
    ResetPasswordForm_captcha_required: "Confirm You are not a robot. ",
    ResetPasswordForm_info: "Enter username. Instruction for reset password will be sent to your registered e-mail.",
    ResetPasswordForm_button_obnovitHeslo: "Reset password",
    PasswordChangePage_title: "Password setting",
    NewPasswordForm_button_nastavitHeslo: "Set password",
    PasswordChangePage_hesloNastaveno: "The password was set. You can log in.",
    PasswordChangePage_continueLogin: "Continue to login",
    TypAutentizace_JMENO_HESLO: "Username ({0}) and password",
    TypAutentizace_NIA: "Identita občana",
    TypAutentizace_MOJE_ID: "MojeID",
    TypAutentizace_ISDS: "ISDS",
    TypAutentizace_JMENO_HESLO_INVALID: "Name and password not set.",
    TypAutentizace_NIA_INVALID: "eidentita not connected.",
    TypAutentizace_MOJE_ID_INVALID: "Acount MojeID not connected.",
    TypAutentizace_ISDS_INVALID: "ISDS not connected.",
    ProcessLoginPage_procesPrihlaseni: "Logging",
    ProcessLoginPage_chybaPrihlaseni: "Login error",
    ProcessLoginForm_button_dokoncitPrihlaseni: "Finish login",
    ProcessLoginPage_action_opakovatPrihlaseni: "Repeat login",
    ProcessLoginPage_action_zmenitPrihlaseni: "Change login method",
    ProcessLoginPage_loginError: "Login failed. Try it later. ",
    ProcessLoginPage_maloDat1: "Reguired data for login were not provided. ",
    ProcessLoginPage_maloDat2: "Repeat login, please. ",
    ProcessLoginPage_registraceJmenoHesloNotSupported: "Registration for the username/ password login method has to be done at the local authority office. ",
    ProcessLoginPage_nepredano: "not provided",
    ProcessLoginPage_predano: "provided",
    ProcessLoginPage_malaUroven: "Level of Assurance of the account is too low. ",
    ProcessLoginPage_jmeno: "Name",
    ProcessLoginPage_prijmeni: "Surname",
    ProcessLoginPage_datumNarozeni: "Date of birth",
    ProcessLoginPage_adresa: "Address",
    ProcessLoginPage_urovenDuveryhodnosti: "Level of Assurance",
    ProcessLoginPage_nodata_jmenoPrijmeni: "Name and surname were not provided",
    ProcessLoginPage_nodata_adresa: "Address was not provided",
    ProcessLoadingPage: "Loading..."

}
